import styled from "styled-components";
import colours from "styles/colours";
import fonts, { fontWeights } from "styles/fonts";

export const PageContainer = styled.div`
  width: 85vw;
  position: relative;
  left: calc(-35vw + 50%);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  position: relative;
  min-height: 100vh;
`;

export const WarningContainer = styled.div`
  display: flex;
  border: 1px solid ${colours.focusBlue};
  border-radius: 3px;
  width: 30em;

  > p {
    display: flex;
    align-items: center;
    padding: 10px;

    > b {
      margin: 0 3px;
    }
  }

  > span {
    display: flex;
    align-items: center;
    padding: 25px 10px;
    margin-left: 15px;
  }
`;

export const TilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 65vw;

  > *:nth-child(2) {
    align-self: flex-end;
    margin-right: 12%;
  }
`;

export const OverflowContainer = styled.span`
  position: relative;
  width: 100%;
`;

export const SidebarContainer = styled.div`
  position: relative;
  width: 20vw;
  display: flex;
  flex-direction: column;
  background-color: ${colours.lighterGrey};
  font: ${fonts.smallMedium};
  font-weight: ${fontWeights.semiBold};
  padding: 0 16px 0 16px;
  margin-bottom: 40px;
  border-left: 1px solid ${colours.elexonBlue};
  min-height: 100%;
`;

export const SidebarHeader = styled.h2`
  && {
    font: ${fonts.xSmall};
    padding: 24px 16px 24px 16px;
  }
`;

export const SidebarContent = styled.div`
  margin-left: -24px;
  padding: 5px 16px;

  & > p {
    font-weight: ${fontWeights.normal};
  }

  ul {
    font-weight: ${fontWeights.normal};
  }
`;
